// ============================================================
// SHOPIFY THEME JAVASCRIPT
// CUSTOM EVENT PUBLISHERS
//
// ADD THIS TO:
// assets/theme.js
// OR
// assets/global.js
//
// REQUIRED FOR:
// 1. consultation_booked
// 2. whatsapp_conversation_started
// 3. phone_consultation_started
//
// THIS CODE DOES NOT SEND DIRECTLY TO POSTHOG.
// IT PUBLISHES SHOPIFY CUSTOM EVENTS.
// THE CUSTOM PIXEL RECEIVES THEM AND SENDS TO POSTHOG.
// ============================================================


// ============================================================
// EVENT: WHATSAPP CONVERSATION STARTED
// Fires when customer clicks WhatsApp link.
// ============================================================

document.addEventListener(
  'click',
  function (event) {

    var element = event.target;

    if (!element) {
      return;
    }

    var link = element.closest(
      'a[href*="wa.me"], a[href*="whatsapp.com"]'
    );

    if (!link) {
      return;
    }

    if (typeof Shopify === 'undefined') {
      return;
    }

    if (!Shopify.analytics) {
      return;
    }

    if (!Shopify.analytics.publish) {
      return;
    }

    var data = {};

    data.source = window.location.pathname;
    data.product_id =
      link.getAttribute('data-product-id');
    data.product_title =
      link.getAttribute('data-product-title');

    Shopify.analytics.publish(
      'my_store:whatsapp_conversation_started',
      data
    );
  }
);


// ============================================================
// EVENT: PHONE CONSULTATION STARTED
// Fires when customer clicks a tel: link.
// ============================================================

document.addEventListener(
  'click',
  function (event) {

    var element = event.target;

    if (!element) {
      return;
    }

    var link = element.closest(
      'a[href^="tel:"]'
    );

    if (!link) {
      return;
    }

    if (typeof Shopify === 'undefined') {
      return;
    }

    if (!Shopify.analytics) {
      return;
    }

    if (!Shopify.analytics.publish) {
      return;
    }

    var data = {};

    data.source = window.location.pathname;
    data.product_id =
      link.getAttribute('data-product-id');
    data.product_title =
      link.getAttribute('data-product-title');

    Shopify.analytics.publish(
      'my_store:phone_consultation_started',
      data
    );
  }
);


// ============================================================
// EVENT: CONSULTATION BOOKED
//
// CALL THIS FUNCTION ONLY AFTER THE BOOKING SYSTEM
// CONFIRMS THAT THE CONSULTATION WAS CREATED SUCCESSFULLY.
// ============================================================

function publishConsultationBooked(booking) {

  if (typeof Shopify === 'undefined') {
    return;
  }

  if (!Shopify.analytics) {
    return;
  }

  if (!Shopify.analytics.publish) {
    return;
  }

  var data = {};

  data.booking_id = null;
  data.consultation_type = null;
  data.consultant_id = null;
  data.booking_date = null;
  data.booking_time = null;
  data.source = window.location.pathname;

  if (booking) {

    if (booking.id) {
      data.booking_id = booking.id;
    }

    if (booking.type) {
      data.consultation_type = booking.type;
    }

    if (booking.consultant_id) {
      data.consultant_id = booking.consultant_id;
    }

    if (booking.date) {
      data.booking_date = booking.date;
    }

    if (booking.time) {
      data.booking_time = booking.time;
    }
  }

  Shopify.analytics.publish(
    'my_store:consultation_booked',
    data
  );
}

// ============================================================
// BOOKING SUCCESS EXAMPLE
//
// ADAPT THIS TO YOUR EXISTING BOOKING CODE.
// DO NOT FIRE THE EVENT ON BUTTON CLICK.
// ============================================================
//
// if (bookingResponse.success) {
//
//   publishConsultationBooked(
//     bookingResponse.booking
//   );
// }
//
// ============================================================
// END OF THEME CODE
// ============================================================
